import styled from "styled-components";
import { theme } from "../../styles/theme";

export const StyledModalHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	margin-bottom: 25px;

	h2 {
		font-family: ${theme.font.primary};
		font-size: 18px;
		font-weight: 700;
		line-height: 1.22;
		color: ${theme.color.black};

		display: flex;
		align-items: flex-end;
		column-gap: 2rem;

		& img {
			height: 2rem;
		}

		& > div * {
			display: block;
		}

		& > div span {
			display: flex;
			align-items: center;
			column-gap: 0.75rem;

			cursor: pointer;
		}
	}
`;
